async function getPartnersData() {
  const { data } = await useFetch("/api/partners", {
    key: "partners-cache",
    cache: "reload",
  });

  if (!Array.isArray(data.value)) {
    return {
      images: [],
      partners: [],
    };
  }

  const images = data.value
    .map((partner) =>
      partner.media?.find(
        (m: any) => m.collection_name === "partner.anteprima_picture"
      )?.original_url
    )
    .filter(Boolean);

  const partners = data.value
    .map((partner) => {
      const image = partner.media?.find(
        (m: any) => m.collection_name === "partner.anteprima_picture"
      )?.original_url;

      if (!image) return null;

      return {
        title: partner.title,
        image,
      };
    })
    .filter(Boolean) as { title: string, image: string }[];

  return { images, partners };
}

export { getPartnersData };
